var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isSubgroupHidden,
      expression: "isSubgroupHidden"
    }],
    class: ['swatches-view-swatches-wrapper-swatches', _vm.subgroup.name + '-container', {
      center: _vm.isContainerCenter,
      'swatches-view-swatches-wrapper-swatches--first-subgroup': _vm.isFirstSubgroup
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.hasNoSubgroups,
      expression: "!hasNoSubgroups"
    }],
    class: ['subgroup-title', _vm.subgroup.name + '-group']
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.getUpchargeDisplay(_vm.groupName, _vm.subgroup.name)))]), _vm.ugcBlockedPalette || _vm.subgroup.tooltip_text ? _c('v-popover', {
    staticClass: "swatches-view-swatches-wrapper-swatches-ugc-block",
    attrs: {
      "delay": {
        'show': 500
      },
      "popoverClass": ['swatches-view-v-popover ', {
        'ugc-block': _vm.ugcBlockedPalette,
        'stitching-message': _vm.subgroup.tooltip_text
      }],
      "placement": "top",
      "trigger": "hover click"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.subgroup.display_name) + "\n        "), _c('span', {
    staticClass: "icon-help"
  })]), _c('template', {
    slot: "popover"
  }, [_vm.ugcBlockedPalette ? _c('div', [_vm._v(_vm._s(_vm.ugcBlockedPaletteMessage))]) : _c('div', [_vm._v(_vm._s(_vm.subgroup.tooltip_text))])])], 2) : _c('span', {
    staticClass: "title",
    on: {
      "click": function click($event) {
        return _vm.showSelectedModal();
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.subgroup.display_name) + "\n      "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hasModal,
      expression: "hasModal"
    }],
    staticClass: "icon-help"
  })]), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.subgroup.subtitle))])], 1), _vm._l(_vm.swatchesArray, function (swatch) {
    return _c('v-popover', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.showSwatch(swatch),
        expression: "showSwatch(swatch)"
      }],
      key: "".concat(_vm.subgroup.name, "-").concat(swatch.id).concat(swatch.color ? '-' + swatch.color : ''),
      ref: "pop-swatch-".concat(swatch.id),
      refInFor: true,
      staticClass: "swatches-view-swatches-wrapper-swatches-container",
      attrs: {
        "delay": {
          'show': 500
        },
        "disabled": !!_vm.ugcBlockedPalette || Number(swatch.id) == 10900,
        "popoverClass": "swatches-view-v-popover",
        "placement": "top",
        "trigger": "hover click"
      }
    }, [_c('button', {
      key: swatch.id + (swatch.color || ''),
      ref: "swatch-".concat(swatch.id),
      refInFor: true,
      class: ['swatch', _vm.subgroup.name, swatch.check_icon_color, {
        'disabled': _vm.blockedSwatches[swatch.id] || !!_vm.ugcBlockedPalette
      }],
      style: "width: ".concat(_vm.widthSwatch),
      attrs: {
        "aria-hidden": _vm.showSwatch(swatch) ? false : true,
        "aria-pressed": _vm.showCheckedIcon(swatch) ? 'true' : 'false',
        "aria-label": _vm.returnSwatchName(swatch.display_name),
        "data-swatch-id": swatch.id,
        "data-swatch-name": _vm.returnSwatchName(swatch.display_name),
        "data-swatch-group": swatch.ugc_swatch_group,
        "data-subgroup": _vm.subgroup.name,
        "data-group": _vm.groupName,
        "data-color": swatch.color
      },
      on: {
        "click": function click($event) {
          return _vm.selectSwatch(swatch);
        },
        "mouseover": function mouseover($event) {
          return _vm.setSwatchMessage(swatch);
        },
        "focus": function focus($event) {
          return _vm.onSwatchFocus(swatch);
        },
        "blur": function blur($event) {
          return _vm.onSwatchBlur(swatch);
        },
        "keydown": function keydown($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
          return _vm.onSwatchEsc(swatch);
        }
      }
    }, [_c('div', {
      class: "background ".concat(_vm.zoomLevelHigh ? 'zoom-level-high' : ''),
      style: _vm.swatchBackgroundStyle(swatch)
    }, [_vm.ugcBlockedPalette ? _c('div', {
      staticClass: "swatches-view-swatches-wrapper-swatches-container-ugc-lock"
    }, [_c('img', {
      staticClass: "customs-header-icon",
      attrs: {
        "alt": "customs-header-icon",
        "aria-hidden": "true",
        "src": "".concat(_vm.$store.state.endPoints.customizer.customsAssets, "/svg/customizer/icon-lock.svg")
      }
    })]) : _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.showCheckedIcon(swatch),
        expression: "showCheckedIcon(swatch)"
      }],
      staticClass: "icon-check-swatch"
    }), _vm.shouldShowRemoveIcon(swatch) ? _c('button', {
      staticClass: "button-remove-swatch",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.removePyocSwatch(swatch);
        }
      }
    }, [_c('span', {
      staticClass: "button-remove-swatch__background"
    }), _c('span', {
      staticClass: "button-remove-swatch__icon"
    }, [_vm._v("\n            ×\n          ")])]) : _vm._e()])]), _c('template', {
      slot: "popover"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.swatchMessage)
      }
    })])], 2);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }